<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import store from '@/store'

import Nav from '@/Components/Nav.vue'
import My from '@/Modals/My.vue'
import Headline from '@/Components/Headline.vue'

import Notify from '@/Modals/Notify.vue'

const route = useRoute()

const props = defineProps(['full'])


const isFull = computed(() => {
  return route?.matched[0]?.props?.default?.full
})

const isSingle = computed(() => {
  return route?.matched[0]?.props?.default?.single
})

const hideNav = computed(() => {
  console.log(33333)
  return route?.matched[0]?.props?.default?.hideNav
})

const getRandomNumber = () => {
    let min = 20, max = 40;
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

const reload = () => {
  window.location.reload()
}

store.loadTags()

// onMounted(() => {
//   if (window.Flutter) {
//     window.Flutter.postMessage('openImagePicker')
//   }
// })



</script>

<template>
  <div class="app" :class="{'is-dating' : $root.store.isDatingView}">
    <Headline v-if="isFull"></Headline>
    <header v-if="!isFull && !isSingle" class="header">
      <Link
        :to="{
          name: 'index'
        }"
        class="logo"
      >
        <img src="@/assets/logo.png" alt="" />
        Азбука
      </Link>
      <div class="header__right">

        <Modal v-if="$root.ver > 2" className="header-btn" title="Профиль" :auth="true">
          <Icon name="user" />
          <template #content>
            <My />
          </template>
        </Modal>

        <Modal className="header-btn" title="Уведомления" :auth="true">
          <Icon name="bell" />
          <template #content>
            <Notify />
          </template>
        </Modal>
        <!-- <Link
          :to="{
            name: 'auth'
          }"
          class="header-btn"
        >
          <Icon name="user" />
        </Link> -->
      </div>
    </header>
    <div v-if="!isFull && !isSingle" class="tags">
      <router-link
        class="tag"
        :to="{
          name: 'events'
        }">
        События ⚡️
      </router-link>
      <router-link 
        class="tag"
        :to="{
          name: 'blog',
          params: {
            id: 38
          }
        }">
        Совет дня 💯
      </router-link>
      <router-link 
        class="tag"
        :to="{
          name: 'blog',
          params: {
            id: getRandomNumber()
          }
        }">
        Случайный совет 🎱
      </router-link>
      <router-link 
        class="tag"
        :to="{
          name: 'blog',
          params: {
            id: 51
          }
        }">
        Чем заняться зимой ⛄️
      </router-link>
      <router-link 
        class="tag"
        :to="{
          name: 'blog',
          params: {
            id: 50
          }
        }">
        Добавить огонька 🔥
      </router-link>
    </div>
    <div class="content">
      <div class="sidebar" v-if="$root.store.size.md && !isSingle">
        <Nav />
      </div>
      <div class="main">
        <router-view></router-view>
      </div>
    </div>
    
    <footer class="footer" v-if="!hideNav && !isSingle">
      <router-link
        :to="{
          name: 'agreement'
        }"
      >
        Пользовательское соглашение
      </router-link>
      <router-link
        :to="{
          name: 'help'
        }"
      >
        Помощь
      </router-link>
    </footer>

    <Nav v-if="!$root.store.size.md && !hideNav && !isSingle" />
  </div>

  <!-- <button class="reload" @click.prevent="reload">
    @
  </button> -->
</template>
  

<style lang="scss">
.reload {
  position: fixed;
  bottom: 10px;
  left: 10px;
  width: 50px;
  height: 50px;
  background: #333;
  color: #FFF;
  border-radius: 6px;
}
#app {
  //padding: 0 var(--gutter);
}
.app {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 10px var(--gutter);
}

.tags {
  width: 100%;
  display: flex;
  gap: 10px;
  overflow-x: scroll;
  white-space: nowrap;
  margin: 10px 0;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.tag {
  background: var(--background-primary);
  border-radius: 8px;
  display: flex;
  gap: 5px;
  padding: 0 8px;
  height: 30px;
  align-items: center;

  @include mq('md') {
    .tags & {
      background: var(--background);
    }
  }
}

.header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 10px;

  &__right {
    margin-left: auto;
    display: flex;
    gap: 10px;
  }
}

.header-btn {
  background: var(--background-secondary);
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 24px;
  color: #333;
  font-weight: bold;

  @include mq('md') {
    font-size: 32px;
  }

  img {
    height: 40px;
    width: 40px;
    border-radius: 12px;

    @include mq('md') {
      height: 60px;
      width: 60px;
    }
  }
}

.content {
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  gap: 20px;
}

.sidebar {
  width: 170px;
  flex-shrink: 0;
  position: sticky;
  top: 10px;
  height: fit-content;
}

.main {
  width: 100%;
  @include mq('md') {
    max-width: calc(100% - 190px);
  }
}

.footer {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 100px;

  a {
    font-weight: bold;
  }
}
</style>
